import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite fullHeightModal" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "horizontalForm mt-4" }
const _hoisted_7 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_8 = { class: "form-group squareInputContainer withLabel mt-3" }
const _hoisted_9 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_user_profile_image = _resolveComponent("user-profile-image")!
  const _component_file_selector = _resolveComponent("file-selector")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "fs_12 spaceCadet d-block ln_12",
          localizedKey: "app_nuovogruppo",
          text: "Nuovo gruppo"
        }),
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue d-block ln_12",
          localizedKey: "app_aggiungiinformazioni",
          text: "Aggiungi informazioni"
        })
      ]),
      _hoisted_5
    ]),
    _createVNode(_component_file_selector, {
      modelValue: _ctx.vm.image,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.image = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_user_profile_image, {
          class: "profileImageRound",
          src: _ctx.preview
        }, null, 8, ["src"]),
        _createVNode(_component_localized_text, {
          localizedKey: "app_cambiafotogruppo",
          text: "Cambia foto gruppo",
          class: "fs_14 grey d-block text-center mt-2"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_nomegruppo",
            text: "Nome gruppo",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "genericInput squareInput",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.vm.name = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.name]
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_inserisciDescrizioneGruppo",
            text: "Inserisci una descrizione per questo gruppo",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("textarea", {
          class: "genericInput squareInput ptInput",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.vm.description = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.description]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("button", {
        class: "genericButton bgGreyBlue w-100",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createRoom())),
        disabled: !_ctx.canSend
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_14 white",
          localizedKey: "app_creaGruppo",
          text: "Crea gruppo"
        })
      ], 8, ["disabled"])
    ])
  ]))
}